import React, { Component } from 'react';
import _ from 'underscore';
import { mixinsClassName, dom } from '../../utils';

export class Input extends Component {
    btnCloseToggle() {
        var keyword = this.refs.input.value.trim();
        dom(this.refs.btnClose)[keyword ? 'show' : 'hide']();
    }

    clearText() {
        this.refs.input.value = "";
    }

    getValue() {
        return this.refs.input.value.trim();
    }

    onChange(ev) {
        const { onChange } = this.props;

        onChange && onChange(ev, ev.target.value);
        this.btnCloseToggle();
    }

    onInput(ev) {
        const { onInput } = this.props;

        onInput && onInput(ev, ev.target.value);
        this.btnCloseToggle();
    }

    onClear(ev) {
        const { onClear } = this.props;
        let inputEl = this.refs.input;

        inputEl.value = "";
        onClear && onClear();
        this.btnCloseToggle();
        inputEl.focus();
    }

    onKeyDown(ev) {
        const { onEnter, onKeyDown } = this.props;
        let keyCode = ev.keyCode || ev.which;
        if (keyCode === 13) {
            onEnter && onEnter(ev);
        }
        onKeyDown && onKeyDown(ev);
    }

    render() {
        let { className, inputClassName, closeClassName } = this.props;
        let inputProps = _.pick(this.props, 'type', 'placeholder', 'maxLength');

        className = mixinsClassName('ui-input', this.props.className);
        closeClassName = mixinsClassName('icon icon-close-circle', closeClassName);
        inputProps = _.extend({
            type: 'text'
        }, inputProps, {
            className: mixinsClassName('form-control', inputClassName)
        });

        return (
            <div className={className} onMouseEnter={this.btnCloseToggle.bind(this)} onMouseLeave={this.btnCloseToggle.bind(this)}>
                <input ref="input" {...inputProps} onInput={this.onInput.bind(this)} onChange={this.onChange.bind(this)} onKeyDown={this.onKeyDown.bind(this)}/>
                <a ref="btnClose" className={closeClassName} onClick={this.onClear.bind(this)}></a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ui/input/base.js